var map = {
	"./advertiser_ja.json": "./src/locales/advertiser_ja.json",
	"./agency_ja.json": "./src/locales/agency_ja.json",
	"./campaignPeriod_ja.json": "./src/locales/campaignPeriod_ja.json",
	"./campaignReport_ja.json": "./src/locales/campaignReport_ja.json",
	"./campaign_ja.json": "./src/locales/campaign_ja.json",
	"./common_ja.json": "./src/locales/common_ja.json",
	"./cpmcreativereport_ja.json": "./src/locales/cpmcreativereport_ja.json",
	"./cpxReport_ja.json": "./src/locales/cpxReport_ja.json",
	"./creativereport_ja.json": "./src/locales/creativereport_ja.json",
	"./login_ja.json": "./src/locales/login_ja.json",
	"./submissionConfirmationCampaignList_ja.json": "./src/locales/submissionConfirmationCampaignList_ja.json",
	"./submissionConfirmationCreativeSetting_ja.json": "./src/locales/submissionConfirmationCreativeSetting_ja.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locales sync recursive [A-Za-z0-9-_,\\s]+\\.json$i";